module.exports = __webpack_public_path__ + "img/icon_result_header.d5f7fb7e.png";